import {Routes,CanActivate} from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import {AuthComponent} from './layout/auth/auth.component';
import {PublicComponent} from './layout/public/public.component';
import {AuthGuardService as AuthGuard } from './services/base-services/auth-guard.service';
export const AppRoutes: Routes = [ {
    path: '',
    component: AuthComponent,
    children: [
      // {
      //   path: 'authentication',
      //   loadChildren: './pages/authentication/authentication.module#AuthenticationModule'
      // },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'maintenance/offline-ui',
        loadChildren: './pages/maintenance/offline-ui/offline-ui.module#OfflineUiModule'
      }, {
        path: 'login',
        loadChildren: './pages/authentication/login/login.module#LoginModule'
      }, {
        path: 'forgot-password/:url_code',
        loadChildren: './pages/authentication/change-password/change-password.module#ChangePasswordModule'
      }, {
        path: 'success-change-password',
        loadChildren: './pages/authentication/success-change-password/success-change-password.module#SuccessChangePasswordModule'
      }, {
        path: 'activation-account/:url_code',
        loadChildren: './pages/authentication/activation-account/activation-account.module#ActivationAccountModule'
      }
    ]
  },{
    path: '',
    component: PublicComponent,
    children: [
      // {
      //   path: 'authentication',
      //   loadChildren: './pages/authentication/authentication.module#AuthenticationModule'
      // },
      {
        path: 'body-composition-detail/:id/:token',
        loadChildren: './pages/public/body-composition-detail/body-composition-detail.module#BodyCompositionDetailModule'
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [ {
        path: 'animations',
        loadChildren: './pages/animations/animations.module#AnimationsModule'
      }, {
        path: 'maintenance/error',
        loadChildren: './pages/maintenance/error/error.module#ErrorModule'
      }, {
        path: 'maintenance/coming-soon',
        loadChildren: './pages/maintenance/coming-soon/coming-soon.module#ComingSoonModule'
      }, {
        path: 'dashboard',
        loadChildren: './pages/beranda/beranda.module#BerandaModule',
        canActivate : [AuthGuard]
      }, {
        path: 'role',
        loadChildren: './pages/trainer/role.module#RoleModule',
        canActivate : [AuthGuard]
      }, {
        path: 'trainer',
        loadChildren: './pages/trainer/trainer.module#TrainerModule',
        canActivate : [AuthGuard]
      }, {
        path: 'booking',
        loadChildren: './pages/booking/booking.module#BookingModule',
        canActivate : [AuthGuard]
      }, {
        path: 'content',
        loadChildren: './pages/content/content.module#ContentModule',
        canActivate : [AuthGuard]
      }, {
        path: 'users',
        loadChildren: './pages/users/users.module#UsersModule',
        canActivate : [AuthGuard]
      }, {
        path: 'admin',
        loadChildren: './pages/admin/admin.module#AdminModule',
        canActivate: [AuthGuard]
      }, {
        path: 'speciality',
        loadChildren: './pages/speciality/speciality.module#SpecialityModule',
        canActivate: [AuthGuard]
      }, {
        path: 'voucher',
        loadChildren: './pages/voucher/voucher.module#VoucherModule',
        canActivate: [AuthGuard]
      }, {
        path: 'event',
        loadChildren: './pages/event/event.module#EventModule',
        canActivate: [AuthGuard]
      }, {
        path: 'quantity',
        loadChildren: './pages/package/package.module#PackageModule',
        canActivate: [AuthGuard]
      }, {
        path: 'body-composition',
        loadChildren: './pages/body-composition/body-composition.module#BodyCompositionModule',
        canActivate: [AuthGuard]
      }, {
        path: 'company',
        loadChildren: './pages/company/company.module#CompanyModule',
        canActivate: [AuthGuard]
      }, {
        path: 'b2b-user',
        loadChildren: './pages/b2b-user/b2b-user.module#B2bUserModule',
        canActivate: [AuthGuard]
      }, {
        path: 'nutritionist',
        loadChildren: './pages/nutricionist/nutricionist.module#NutricionistModule',
        canActivate: [AuthGuard]
      }, {
        path: 'category',
        loadChildren: './pages/category/category.module#CategoryModule',
        canActivate: [AuthGuard]
      },{
        path: 'b2b-event',
        loadChildren: './pages/b2b-event/b2b-event.module#B2bEventModule',
        canActivate: [AuthGuard]
      },{
        path: 'b2b-group',
        loadChildren: './pages/b2b-group/b2b-group.module#B2bGroupModule',
        canActivate: [AuthGuard]
      },{
        path: 'b2b-training-attendance',
        loadChildren: './pages/b2b-training-attendance/b2b-training-attendance.module#B2bTrainingAttendanceModule',
        canActivate: [AuthGuard]
      },{
        path: 'b2b-report-biweekly',
        loadChildren: './pages/b2b-report-biweekly/b2b-report-biweekly.module#B2bReportBiweeklyModule',
        canActivate: [AuthGuard]
      },{
        path: 'b2b-report-wellness-performance',
        loadChildren: './pages/b2b-report-wellness-performance/b2b-report-wellness-performance.module#B2bReportWellnessPerformanceModule',
        canActivate: [AuthGuard]
      },{
        path: 'client-exclusive',
        loadChildren: './pages/client-exclusive/client-exclusive.module#ClientExclusiveModule',
        canActivate: [AuthGuard]
      },{
        path: 'webinar',
        loadChildren: './pages/webinar/webinar.module#WebinarModule',
        canActivate: [AuthGuard]
      },{
        path: 'privilege',
        loadChildren: './pages/privilege/privilege.module#PrivilegeModule',
        canActivate: [AuthGuard]
      },{
        path: 'exercise',
        loadChildren: './pages/exercise/exercise.module#ExerciseModule',
        canActivate: [AuthGuard]
      }
    ]
  }
];



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/PROD-mufit-web/src/app/app.routing.ts